module.exports = __webpack_public_path__ + "img/design.39216a68.svg";